import React, { useEffect, useState, useRef } from 'react';
import VehicleService from '../../services/VehicleService';
import { Form, Row, Col, Input, Alert, Select } from 'antd';
import './style.css';

const { Option } = Select;

const BanDoComponent = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSource, setSelectedSource] = useState('all');
  const [isMapReady, setIsMapReady] = useState(false);


  // Refs cho container map, instance map, danh sách marker và popup
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);
  const popupRef = useRef(null);

  // Hàm hiển thị popup khi click vào marker
  const displayPopup = (vehicle) => {
    const map = mapInstanceRef.current;
    if (!map) return;

    const lng = parseFloat(vehicle.Longitude);
    const lat = parseFloat(vehicle.Latitude);
    if (isNaN(lng) || isNaN(lat)) return;

    console.log("Popup location - lng:", lng, "lat:", lat);

    const html = `
      <div style="font-size:13px; line-height:1.4;">
        <strong>Biển số:</strong> ${vehicle.VehiclePlate || vehicle.VehicleNo || 'Không rõ'}<br/>
        <strong>Địa chỉ:</strong> ${vehicle.Address || 'Không rõ'}<br/>
        <strong>Tốc độ:</strong> ${vehicle.Speed || 0} km/h<br/>
        ${
          vehicle.source === 'HMExpress'
            ? `
              <strong>Nhiệt độ 1:</strong> ${vehicle.Temperature1 ?? '-'} °C<br/>
              <strong>Nhiệt độ 2:</strong> ${vehicle.Temperature2 ?? '-'} °C<br/>
              <strong>Trạng thái:</strong> ${vehicle.CarStatus ?? '-'}<br/>
            `
            : `<strong>Nhiệt độ:</strong> ${vehicle.Temperature ?? '-'} °C<br/>`
        }
      </div>
    `;

    console.log('Thông tin xe:', html);

    // Tạo một popup mới cho mỗi marker, không sử dụng popupRef chung
    const popup = new window.goongjs.Popup({
      offset: 25,
      closeButton: true,
      closeOnClick: false,
    })
      .setLngLat([lng, lat])
      .setHTML(html)
      .addTo(map);
  };


  // Khởi tạo bản đồ khi component mount
  useEffect(() => {
    if (!mapInstanceRef.current && window.goongjs) {
      window.goongjs.accessToken =
        process.env.REACT_APP_GOONG_MAP_TILES_KEY || 'pM4TRHbAYk4I8IwnAivYZo8fbBBVcRhM4fir8PFy';

      const map = new window.goongjs.Map({
        container: mapContainerRef.current,
        style: 'https://tiles.goong.io/assets/goong_map_web.json',
        center: [105.83991, 21.02800],
        zoom: 9,
      });

      // Gán instance ngay sau khi tạo, tránh gán trong 'load' event
      mapInstanceRef.current = map;

      map.on('load', () => {
        console.log("Map loaded successfully");
        setIsMapReady(true); // Đánh dấu là bản đồ đã sẵn sàng
        updateMarkers(); // Cập nhật marker sau khi bản đồ đã sẵn sàng
      });

      map.on('move', () => {
        console.log('Map is moving');
      });

      map.on('moveend', () => {
        console.log('Map movement ended');
      });

      map.on('error', (e) => {
        console.error("Map load error:", e);
      });
    }

    return () => {
      if (mapInstanceRef.current) {
        console.log('Removing map instance');
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
        setIsMapReady(false);
      }
    };
  }, []);

  // Lấy dữ liệu xe từ backend
  const fetchAllVehicles = async () => {
    setLoading(true);
    try {
      const [vtrackingData, hmExpressData] = await Promise.all([
        VehicleService.getVehicleData('Vtracking'),
        VehicleService.getVehicleData('HMExpress'),
      ]);
      const combinedData = [
        ...(vtrackingData || []).map(item => ({ ...item, source: 'Vtracking' })),
        ...(hmExpressData || []).map(item => ({ ...item, source: 'HMExpress' })),
      ];
      setVehicles(combinedData);
    } catch (error) {
      console.error('Lỗi khi lấy dữ liệu xe:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllVehicles();
    const interval = setInterval(fetchAllVehicles, 20000);
    return () => clearInterval(interval);
  }, []);

  // Lọc xe theo biển số và nguồn
  const filteredVehicles = vehicles.filter(vehicle => {
    const plate = (vehicle.VehiclePlate || vehicle.VehicleNo || '').toLowerCase();
    return plate.includes(searchTerm.toLowerCase()) && (selectedSource === 'all' || vehicle.source === selectedSource);
  });

  // Cập nhật marker trên map mỗi khi filteredVehicles thay đổi
  const updateMarkers = () => {
    const map = mapInstanceRef.current;
    if (!map || !isMapReady) return;

    // Xóa tất cả marker cũ trước khi thêm mới
    markersRef.current.forEach(marker => marker.remove());
    markersRef.current = [];

    filteredVehicles.forEach(vehicle => {
      const lng = parseFloat(vehicle.Longitude);
      const lat = parseFloat(vehicle.Latitude);
      if (isNaN(lng) || isNaN(lat)) {
        console.warn(`Tọa độ không hợp lệ cho xe ${vehicle.VehiclePlate || vehicle.VehicleNo}`);
        return;
      }

      const vehiclePlate = vehicle.VehiclePlate || vehicle.VehicleNo;

      // Tạo marker mới
      const el = document.createElement('img');
      el.src =
        vehicle.source === 'HMExpress'
          ? `${process.env.PUBLIC_URL}/images/container-icon.png`
          : `${process.env.PUBLIC_URL}/images/truck-icon.png`;
      el.style.width = vehicle.source === 'HMExpress' ? '56px' : '32px';
      el.style.height = vehicle.source === 'HMExpress' ? '56px' : '32px';
      el.style.cursor = 'pointer';
      el.dataset.vehiclePlate = vehiclePlate;

      // Sự kiện click để hiện popup
      el.addEventListener('click', () => displayPopup(vehicle));

      const marker = new window.goongjs.Marker({ element: el })
        .setLngLat([lng, lat])
        .addTo(map);

      markersRef.current.push(marker);
    });
  };

  // Cập nhật marker khi danh sách xe thay đổi
  useEffect(() => {
    if (isMapReady) {
      updateMarkers();
    }
  }, [filteredVehicles, isMapReady]);


  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Phần tìm kiếm */}
      <div
        style={{
          backgroundColor: '#fff',
          padding: '15px',
          borderBottom: '1px solid #e8e8e8',
          boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
          zIndex: 2,
        }}
      >
        <Form layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Form.Item label="Tìm kiếm biển số">
                <Input
                  placeholder="Nhập biển số xe"
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Nguồn xe">
                <Select
                  placeholder="Chọn nguồn xe"
                  value={selectedSource}
                  onChange={value => setSelectedSource(value)}
                >
                  <Option value="all">Tất cả</Option>
                  <Option value="Vtracking">Vtracking</Option>
                  <Option value="HMExpress">HMExpress</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16,16]}>
            <Col span={24}>
              <div style={{ marginTop: 10, fontWeight: 'bold' }}>
                Tổng số xe hiển thị: {filteredVehicles.length}
              </div>
            </Col>
          </Row>
        </Form>
      </div>

      {/* Phần bản đồ */}
      <div style={{ flex: 1, position: 'relative' }}>
        {loading && (
          <Alert
            message="Đang tải dữ liệu..."
            type="info"
            showIcon
            style={{
              position: 'absolute',
              top: '10px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 2,
            }}
          />
        )}
        <div id="map" ref={mapContainerRef} style={{ width: '100%', height: '85%' }} />
      </div>
    </div>
  );
};

export default BanDoComponent;